import { ActionCommand } from '@nextforce/api'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { SwapCoverShiftScreenProps } from 'home/stack/types'
import React, { useCallback, useLayoutEffect } from 'react'
import { errorAlert } from 'shared/alerts'
import { showHeaderTitle } from 'shared/header/header_title'
import { usePerformShiftAction } from 'shifts/queries/perform_action'
import { SwapCoverShiftView } from 'shifts/screens/swap_cover_shift/view'

export function SwapCoverShiftScreen({
  navigation,
  route,
}: SwapCoverShiftScreenProps) {
  const shiftMutation = usePerformShiftAction()
  const { handleNavigation } = useRoutingContext()
  const { shiftData } = route.params

  useLayoutEffect(() => {
    if (shiftData.title) {
      showHeaderTitle(navigation, shiftData.title)
    }
  }, [navigation, shiftData?.title])

  const onConfirm = useCallback(
    async (command: ActionCommand) => {
      try {
        const res = await shiftMutation.mutateAsync(command.action)
        if (res) {
          handleNavigation({
            routeName: 'confirm_shift_action',
            routeParams: { shiftData: res },
          })
        }
      } catch (err: any) {
        errorAlert(
          err,
          shiftData?.type === 'SWAP'
            ? t('swapShiftErrorTitle')
            : t('assignShiftErrorTitle')
        )
      }
    },
    [handleNavigation, shiftData?.type, shiftMutation]
  )

  return (
    <SwapCoverShiftView
      {...{
        shiftData,
        onConfirm,
      }}
    />
  )
}
